// src/pages/AbsensiIbadahPelkat.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../components/common/LoadingSpinner';
import PageTransitionWrapper from '../components/layout/PageTransitionWrapper';

// --- Impor logo-logo Pelkat ---
// Asumsi path ini benar dan file gambar tersedia
import logoPA from '../assets/images/PA.png';
import logoPT from '../assets/images/PT.png';
import logoGP from '../assets/images/GP.png';
import logoPKP from '../assets/images/PKP.png';
import logoPKB from '../assets/images/PKB.png';
import logoPKLU from '../assets/images/PKLU.png';

// Objek untuk memetakan kunci Pelkat ke logo
const pelkatLogos = {
    'PA': logoPA,
    'PT': logoPT,
    'GP': logoGP,
    'PKP': logoPKP,
    'PKB': logoPKB,
    'PKLU': logoPKLU,
};

// Data daftar Absensi Pelkat
const documents = [
    {
        key: 'PA',
        title: 'Absensi Pelkat PA',
        description: 'Formulir absensi kehadiran untuk Pelayanan Anak.',
        link: '/absensi-pelkat/pa',
        color: 'text-green-600', // Warna Pelkat
        hoverColor: 'border-green-600',
    },
    {
        key: 'PT',
        title: 'Absensi Pelkat PT',
        description: 'Formulir absensi kehadiran untuk Pelayanan Remaja.',
        link: '/absensi-pelkat/pt',
        color: 'text-blue-600',
        hoverColor: 'border-blue-600',
    },
    {
        key: 'GP',
        title: 'Absensi Pelkat GP',
        description: 'Formulir absensi kehadiran untuk Gerakan Pemuda.',
        link: '/absensi-pelkat/gp',
        color: 'text-red-600',
        hoverColor: 'border-red-600',
    },
    {
        key: 'PKP',
        title: 'Absensi Pelkat PKP',
        description: 'Formulir absensi kehadiran untuk Persekutuan Kaum Perempuan.',
        link: '/absensi-pelkat/pkp',
        color: 'text-purple-600',
        hoverColor: 'border-purple-600',
    },
    {
        key: 'PKB',
        title: 'Absensi Pelkat PKB',
        description: 'Formulir absensi kehadiran untuk Persekutuan Kaum Bapak.',
        link: '/absensi-pelkat/pkb',
        color: 'text-yellow-600',
        hoverColor: 'border-yellow-600',
    },
    {
        key: 'PKLU',
        title: 'Absensi Pelkat PKLU',
        description: 'Formulir absensi kehadiran untuk Persekutuan Kaum Lanjut Usia.',
        link: '/absensi-pelkat/pklu',
        color: 'text-indigo-600',
        hoverColor: 'border-indigo-600',
    },
];

const AbsensiIbadahPelkat = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    // Efek simulasi loading (tidak berubah)
    useEffect(() => {
        let isCancelled = false;
        let progressInterval;
        const MIN_LOADING_TIME = 1000;
        const DELAY_AFTER_LOAD = 700;

        const simulateLoading = () => {
            setIsLoading(true);
            setProgress(0);
            const startTime = Date.now();

            progressInterval = setInterval(() => {
                const elapsedTime = Date.now() - startTime;
                let calculatedProgress = (elapsedTime / MIN_LOADING_TIME) * 100;
                if (calculatedProgress > 99) calculatedProgress = 99;
                if (!isCancelled) {
                    setProgress(Math.floor(calculatedProgress));
                }
            }, 50);

            setTimeout(() => {
                clearInterval(progressInterval);
                if (!isCancelled) {
                    setProgress(100);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, DELAY_AFTER_LOAD);
                }
            }, MIN_LOADING_TIME);
        };

        simulateLoading();

        return () => {
            isCancelled = true;
            clearInterval(progressInterval);
        };
    }, []);

    return (
        <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-6xl mx-auto">

                {/* 🌈 Card 1: Judul DENGAN DEKORASI */}
                <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-10 relative overflow-hidden border-b-8 border-blue-500">
                    {/* Background Pattern/Gradient */}
                    <div className="absolute top-0 right-0 h-full w-1/4 bg-blue-50 opacity-50 transform skew-x-12 origin-top-right hidden sm:block"></div>
                    <div className="relative z-10">
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-gray-900 text-center mb-2">
                            ABSENSI IBADAH PELKAT
                        </h1>
                        <p className="text-lg text-gray-600 text-center max-w-3xl mx-auto font-medium">
                            Pilih kategori Pelayanan Kategorial di bawah ini untuk menuju formulir absensi kehadiran yang sesuai.
                        </p>
                    </div>
                </div>

                {/* Card 2: Daftar Absensi Pelkat yang Dipercantik */}
                <div className="mt-10 bg-white rounded-2xl shadow-xl p-6 sm:p-10 min-h-[500px] relative">
                    {isLoading ? (
                        <div className="absolute inset-0 flex items-center justify-center">
                            <LoadingSpinner progress={progress} />
                        </div>
                    ) : (
                        <PageTransitionWrapper>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                                {documents.map((doc, index) => (
                                    <Link
                                        key={index}
                                        to={doc.link}
                                        className={`bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.03] 
                                                    border-b-4 border-gray-200 hover:${doc.hoverColor} 
                                                    flex flex-col items-center text-center group`}
                                    >
                                        {/* Logo */}
                                        <div className={`p-3 rounded-full mb-4 transition-all duration-300 ${doc.color.replace('text', 'bg').replace('-600', '-100')} group-hover:shadow-lg group-hover:scale-110`}>
                                            <img
                                                src={pelkatLogos[doc.key]}
                                                alt={`Logo Pelkat ${doc.key}`}
                                                className="w-16 h-16 object-contain"
                                            />
                                        </div>

                                        {/* Judul */}
                                        <h3 className={`text-xl font-extrabold mb-1 transition-colors duration-300 group-hover:${doc.color}`}>{doc.title}</h3>

                                        {/* Deskripsi */}
                                        <p className="text-sm text-gray-500 line-clamp-2">{doc.description}</p>

                                        {/* Tombol Aksi (Hanya Dekorasi) */}
                                        <div className={`mt-4 text-sm font-semibold transition-colors duration-300 ${doc.color} group-hover:underline`}>
                                            Lihat Formulir &rarr;
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </PageTransitionWrapper>
                    )}
                </div>
            </div>
        </div >
    );
};

export default AbsensiIbadahPelkat;